module.exports = __webpack_public_path__ + "media/images/flags/16/Vanuatu-da23077a8334098b93479b6f67fc6205.png";